export default __webpack_public_path__ + "static/media/icon_movie.328eb5a6.svg";